import React from "react"
import styled from "styled-components"

import leader1 from "../assets/images/leader1.jpg"
import imageBanner from "../assets/images/banner_bg_2.png"
import kgawronska from "../assets/images/kgawronska-medinvest.jpg"
import kkujawa from "../assets/images/kaja-kujawa-medinvest.jpg"

import Layout from "../components/Layout/Layout"
import SEO from "../components/SEO/SEO"
import H1 from "../components/H1/H1"
import H2 from "../components/H2/H2"
import ContentWrapper from "../components/ContentWrapper/ContentWrapper"
import Banner from "../components/Banner/Banner"
import OnasHeader from "../components/OnasHeader/OnasHeader"

const PersonalImage = styled.div`
  display: flex;
  margin-bottom: 100px;
  flex-direction: column;
  height: auto;
  overflow: visible;
  ${({ theme }) => theme.media.tablet} {
    flex-direction: ${({ even }) => (even ? "row-reverse" : "row")};
    margin: ${({ even }) => (even ? "0 0 150px 50px" : "0 50px 150px 0")};
  }
  img {
    object-fit: cover;
    height: auto;
    width: 300px;
    margin: 0 auto 50px auto;
    ${({ theme }) => theme.media.tablet} {
      height: 500px;
      margin: ${({ even }) => (even ? "0 0 0 50px" : "0 50px 0 0")};
    }
  }
  div {
    h2 {
      padding-left: 65px;
      ::before {
        content: "";
        height: 4px;
        width: 48px;
        background: ${({ theme }) => theme.colors.primary};
        display: inline-block;
        position: absolute;
        left: 0;
        top: calc(50% - 2px);
      }
    }
  }
`

const PartnersPage = () => {
  return (
    <Layout>
      <SEO title="O nas" />
      <div style={{ height: "60px" }} />
      <Banner title="O NAS" image={imageBanner} />
      <ContentWrapper>
        <br />
        <br />
      </ContentWrapper>
      <ContentWrapper>
        <OnasHeader />
        <PersonalImage>
          <img src={leader1} alt="Łukasz Gawroński" />
          <div>
            <H1>Łukasz Gawroński</H1>
            <H2 gold>Prezes Zarządu</H2>
            <p>
              Dzień dobry! Nazywam się Łukasz Gawroński. Na co dzień jestem
              przedsiębiorcą, managerem a przede wszystkim profesjonalnym
              pośrednikiem przy sprzedaży firm i w obrocie nieruchomościami
              sektora medycznego. Doświadczenie zdobywałem latami – studiując
              finanse i rachunkowość, prawo oraz na stanowiskach managera
              agencji nieruchomości, biura deweloperskiego oraz zarządzając
              przychodnią lekarską POZ. Rzadziej, ale z niemniejszym zapałem
              handlowałem towarami oraz sprzętem medycznym. Z branżą jestem
              związany od najmłodszych lat. Pochodzę bowiem z rodziny z lekarską
              tradycją od dziada-pradziada. W naturalny sposób sprawiło to, że
              już jako dziecko zainteresowałem się medycyną. Dorastałem, uczony
              jak zarządzać w służbie zdrowia przez osoby piastujące najwyższe
              kierownicze stanowiska we flagowych Warszawskich szpitalach.
              Wszystko, aby finalnie osiągnąć najwyższy poziom obsługi klienta
              branżowego. Wszystko, aby stworzyć MedInvest.
            </p>
          </div>
        </PersonalImage>
        <PersonalImage>
          <img src={kgawronska} alt="Katarzyna Gawrońska" />
          <div>
            <H1>Lek. Katarzyna Gawrońska</H1>
            <H2 gold>Lekarz Naczelny</H2>
            <p>
              Nazywam się Katarzyna Gawrońska i dla firmy MedInvest pracuję jako Konsultant. Przez lata dorastałam rozwijając i pielęgnując w sonie zaszczepione przez rodzinę pasje oraz zainteresowanie medycyną. Ukończyłam wydział lekarski Warszawskiego Uniwersytetu Medycznego i aktualnie jestem w trakcie specjalizacji z okulistyki. Posiadam nie tylko dużo doświadczeń związanych z pracą w przychodniach POZ czy szpitalach, ale przede wszystkim pośrednictwie sprzedaży tego typu przedsiębiorstw. Znam branżę od podszewki i aktualnie konsultuję MedInvest w sprawach medycznych.
            </p>
          </div>
        </PersonalImage>
        <PersonalImage>
          <img src={kkujawa} alt="Kaja Kujawa" />
          <div>
            <H1>Kaja Kujawa</H1>
            <H2 gold>Dyrektor operacyjny</H2>
            <p>
              Jako ekspertka w zakresie sprzedaży placówek medycznych,
              specjalizuję się w transakcjach z obszaru weterynarii, medycyny
              estetycznej oraz stomatologii. Wspieram właścicieli w całym
              procesie sprzedaży — od precyzyjnej wyceny, przez negocjacje, aż
              po finalizację umowy — zawsze z myślą o maksymalizacji wartości
              transakcji.
              <br />
              Łączę wiedzę o rynku medycznym z praktycznym doświadczeniem w
              obszarze administracji, kadr, płac i finansów, co pozwala mi
              sprawnie poruszać się zarówno w kwestiach formalnych, jak i
              strategicznych. Rozumiem realia branży, potrzeby sprzedających i
              to, jak ważna jest dyskrecja oraz bezpieczeństwo całego procesu.
              <br />
              Reprezentując interesy właściciela, koncentruję się na tym, by
              każda sprzedaż była nie tylko sprawna, ale przede wszystkim
              opłacalna. Moim celem jest znaleźć nie pierwszego — lecz
              najlepszego kupca.
            </p>
          </div>
        </PersonalImage>
      </ContentWrapper>
    </Layout>
  )
}

export default PartnersPage
